import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import {
  MatButtonModule,
  MatCardModule,
  MatDatepickerModule,
  MatFormFieldModule,
  MatIconModule,
  MatMenuModule,
  MatCheckboxModule,
  MatDialogModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatInputModule,
  MatTooltipModule,
} from "@angular/material";
import { downgradeComponent } from "@angular/upgrade/static";
import {
  ApiModule,
} from "src/app/api";
import { CpfCnpjMaskPipeModule } from "../forms/cpf-cnpj-mask.pipe";
import { StateProvider } from "@uirouter/angularjs";
import * as angular from "angular";
import { DashboardModule } from "../dashboard/dashboard.module";
import { ServicesModule } from "../services/services.module";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { FinancialRoutingModule } from "./financial-routing.module";
import { InvoiceListComponent } from "./invoice-list/invoice-list.component";
import { InvoiceListLegacyComponent } from "./invoice-list/invoice-list-legacy.component";
import { RefundListComponent } from "./refund-list/refund-list.component";
import { PaymentProofDialogComponent } from "./invoice-list/payment-proof-dialog/payment-proof-dialog.component";
import { TemporaryReleaseService } from "./invoice-list/temporary-release.service";
import { MdePopoverModule } from "@material-extended/mde";

@NgModule({
  declarations: [InvoiceListComponent, InvoiceListLegacyComponent, DashboardComponent, RefundListComponent, PaymentProofDialogComponent],
  entryComponents: [
    PaymentProofDialogComponent,
    DashboardComponent,
    InvoiceListComponent,
    RefundListComponent,
  ],
  imports: [
    CommonModule,
    DashboardModule,
    FinancialRoutingModule,
    ApiModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    ServicesModule,
    CpfCnpjMaskPipeModule,
    MatButtonModule,
    MatCardModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatCheckboxModule,
    MatDialogModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatTooltipModule,
    MdePopoverModule,
  ],
  providers: [TemporaryReleaseService],
})
export class FinancialModule {}

try {
  angular
    .module("mandaeApp")
    .directive(
      "appFinancialInvoiceList",
      downgradeComponent({ component: InvoiceListComponent })
    )
    .directive(
      "appFinancialDashboard",
      downgradeComponent({ component: DashboardComponent })
    )
    .directive(
      "appFinancialRefundList",
      downgradeComponent({ component: RefundListComponent })
    )
    .config([
      "$stateProvider",
      ($stateProvider: StateProvider) => {
        $stateProvider
          .state({
            name: "financeiro",
            url: "/financeiro?tour",
            redirectTo: "dashboard",
            data: {
              headerMenuItems: [
                {
                  icon: "financial:dashboard",
                  text: "RESUMO",
                  state: "dashboard",
                },
                {
                  icon: "financial:boleto",
                  text: "FATURA",
                  state: "faturas",
                },
                {
                  icon: "financial:money",
                  text: "REEMBOLSO",
                  state: "reembolsos",
                },
              ],
            },
          })
          .state({
            name: "faturas",
            parent: "financeiro",
            url: "/faturas?comprovante",
            component: "appFinancialInvoiceList",
          })
          .state({
            name: "dashboard",
            parent: "financeiro",
            url: "/dashboard",
            component: "appFinancialDashboard",
          })
          .state({
            name: "reembolsos",
            parent: "financeiro",
            url: "/reembolsos",
            component: "appFinancialRefundList",
          });
      },
    ]);
} catch (e) {}
